<!-- eslint-disable -->
<template>
  <v-expansion-panel>
    <v-expansion-panel-header color="blue lighten-4">
      Lotes
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row>
        <v-col cols="12" xl="4" offset-xl="8">
          <v-container>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Busqueda"
              single-line
              hide-details
            />
          </v-container>
        </v-col>
      </v-row>
      <v-data-table
        dense
        mobile-breakpoint="0"
        :headers="headers"
        class="elevation-1"
        :search.sync="search"
        :items="items"
      >
        <template v-slot:[`item.lote`]="{ item }">
          {{ item.lote | folio }}
        </template>
        <template v-slot:[`item.fecha_corte`]="{ item }">
          {{ item.fecha_corte | date }}
        </template>
        <template v-slot:[`item.peso_neto`]="{ item }">
          {{ item.peso_neto | decimal }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon color="primary" @click="getLote(item.id)">
            <v-icon>mdi-information</v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.precio_comisionista`]="{ item }">
          {{ item.precio_comisionista | moneda }}
        </template>
        <template v-slot:[`item.importe_comisionista`]="{ item }">
          {{ item.importe_comisionista | moneda }}
        </template>
      </v-data-table>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "Lotes",
  data: () => ({
    headers: [
      { text: "Fecha", value: "fecha_corte" },
      { text: "Lote", value: "lote" },
      { text: "Huerta", value: "huerta" },
      { text: "Productor", value: "productor" },
      { text: "Precio", value: "precio_comisionista", align: "end" },
      { text: "Peso Neto", value: "peso_neto", align: "end" },
      { text: "Importe", value: "importe_comisionista", align: "end" },
      { text: "Acciones", value: "actions", align: "end" }
    ],
    perPage: 15,
    search: undefined
  }),
  computed: {
    ...mapState({
      items: state => state.Comisionistas.historial.lotes
    })
  },
  methods: {
    ...mapActions("Lotes", ["getLote"])
  }
};
</script>
